/* PROTOCOL · add-button click rescue  (5 Sep 2026)

   Symptom: in the Recommended for you band, most often on the Biomarkers
   tab, the "+ Add" button goes dead. Clicking it does nothing at all.

   Diagnosis, from instrumenting the live page while Mehdi clicked:

     pointerdown -> <BUTTON add-btn> card=Fasting Insulin + HOMA-IR
     mousedown   -> <BUTTON add-btn> card=Fasting Insulin + HOMA-IR
     pointerup   -> <BUTTON add-btn> card=Fasting Insulin + HOMA-IR
     mouseup     -> <BUTTON add-btn> card=Fasting Insulin + HOMA-IR
                                             <-- no click event, ever

   Every pointer event lands on the correct button. The button is not
   disabled, pointer-events is auto, and its inline onclick is intact.
   The browser simply never synthesises the click.

   A click is only dispatched when mousedown and mouseup resolve to the
   same node. If that node is moved or replaced in between, there is no
   common target and the click is dropped silently. renderCards() is NOT
   running during these clicks (verified), so the list is not being
   rebuilt; something is relocating the card node itself. The only code
   that moves existing card nodes is markRepeats() in protocol-renewal.js,
   which appendChild()s repeat items into the Recommended band and is
   re-triggered by a MutationObserver. That band is exactly where the
   failure occurs, and Biomarkers has the most cards to move.

   This file does not attempt to fix the mover. It removes the
   consequence: if a press and release both land on the same add button
   and no click follows within a tick, the toggle is invoked directly.

   Safe by construction:
     - it listens on document, so it survives any node being replaced
     - it only acts when the native click did NOT fire, so it can never
       double-add
     - it reads the product name from the button's own onclick attribute,
       so it stays correct if the catalogue changes
     - it no-ops entirely on pages without the add-ons flow            */
(function(){
  'use strict';

  var armedName = null;

  function nameFrom(btn){
    var a = btn.getAttribute('onclick') || '';
    var m = a.match(/toggleAddByName\(\s*'((?:[^'\\]|\\.)*)'/);
    if(!m) return null;
    /* the attribute is HTML-escaped and single-quote escaped; undo both the
       same way the page's own handler does */
    var s = m[1].replace(/\\'/g, "'").replace(/\\\\/g, '\\');
    var d = document.createElement('textarea');
    d.innerHTML = s;
    return d.value.trim();
  }

  document.addEventListener('pointerdown', function(e){
    var b = e.target && e.target.closest && e.target.closest('.add-btn');
    armedName = b ? nameFrom(b) : null;
  }, true);

  document.addEventListener('pointerup', function(e){
    var name = armedName;
    armedName = null;
    if(!name) return;

    var b = e.target && e.target.closest && e.target.closest('.add-btn');
    if(!b) return;                         /* released elsewhere, not a click */
    if(nameFrom(b) !== name) return;       /* released on a different product */

    var fired = false;
    function seen(){ fired = true; }
    document.addEventListener('click', seen, true);

    setTimeout(function(){
      document.removeEventListener('click', seen, true);
      if(fired) return;                    /* native click worked, do nothing */
      if(typeof window.toggleAddByName !== 'function') return;
      try{ window.toggleAddByName(name, b); }catch(err){}
    }, 0);
  }, true);
})();
